export const en = {
  translation: {
    Hello: "Hello",
    "Not a member?": "Not a member?",
    "Sign Up": "Sign Up",
    Affiliate: "Affiliate",
    "Sign In": "Sign In",
    "Sign in If you have an account in here":
      "Sign in If you have an account in here",
    // New translations for AffiliateSignInForm
    "Your Email": "Your Email",
    Email: "Email",
    Password: "Password",
    "Enter Your Password": "Enter Your Password",
    "Forgot Password?": "Forgot Password?",
    "Invalid email address": "Invalid email address",
    "Email is required": "Email is required",
    "Password must be at least 6 characters long":
      "Password must be at least 6 characters long",
    "Password is required": "Password is required",
    // PasswordCard translations
    "Password Settings": "Password Settings",
    "Current Password": "Current Password",
    "Enter your current password": "Enter your current password",
    "New Password": "New Password",
    "Enter your new password": "Enter your new password",
    "Confirm New Password": "Confirm New Password",
    "Confirm your new password": "Confirm your new password",
    "Change Password": "Change Password",
    "Current password is required": "Current password is required",
    "Password must be at least 8 characters":
      "Password must be at least 8 characters",
    "New password must be different from current password":
      "New password must be different from current password",
    "New password is required": "New password is required",
    "Passwords must match": "Passwords must match",
    "Please confirm your new password": "Please confirm your new password",
    // PersonalInfoCard translations
    "Personal Information": "Personal Information",
    Name: "Name",
    "Update Profile": "Update Profile",
    "First name must be at least 2 characters":
      "First name must be at least 2 characters",
    "Name can only contain letters": "Name can only contain letters",
    "Name is required": "Name is required",
    // StripeConnectionCard translations
    "Stripe Connection": "Stripe Connection",
    Connected: "Connected",
    "Not Connected": "Not Connected",
    "Your Stripe account is connected and ready to receive payments.":
      "Your Stripe account is connected and ready to receive payments.",
    "Connect your Stripe account to start receiving affiliate commissions.":
      "Connect your Stripe account to start receiving affiliate commissions.",
    "Connect with Stripe": "Connect with Stripe",
    // BusinessCard translations
    Reviews: "Reviews",
    // BusinessDesignForm translations
    "General Information": "General Information",
    // SplitLayout translations
    "Affiliate Portal": "Affiliate Portal",
    "Join our affiliate network and earn commissions by helping businesses discover our platform. Connect local businesses with customers and earn rewards for every successful subscription.":
      "Join our affiliate network and earn commissions by helping businesses discover our platform. Connect local businesses with customers and earn rewards for every successful subscription.",
    // StripeConnectSuccess translations
    "Success! Your account is connected to Stripe successfully. Press OK to Continue.":
      "Success! Your account is connected to Stripe successfully. Press OK to Continue.",
    OK: "OK",
    // Referrals translations
    "Referral QR code": "Referral QR code",
    "Share your referral link": "Share your referral link",
    "Refer a New Client and Earn": "Refer a New Client and Earn",
    "50% Commission (first two months per company)": "50% Commission (first two months per company)",
    "How Does Our Referral Program Work?":
      "How Does Our Referral Program Work?",
    "1. Share your unique referral link": "1. Share your unique referral link",
    "2. When someone signs up using your link, they become your referral":
      "2. When someone signs up using your link, they become your referral",
    "3. Earn 50% commission for the first two months for each company you bring in":
      "3. Earn 50% commission for the first two months for each company you bring in",
    "4. Get paid monthly via Stripe": "4. Get paid monthly via Stripe",
    "If a company cancels its membership, it does not count the following month.":
      "If a company cancels its membership, it does not count the following month.",
    "Search referrals by name": "Search referrals by name",
    "Registration Date": "Registration Date",
    Bonus: "Bonus",
    "Commission Payout": "Commission Payout",
    "Projected Commission": "Projected Commission",
    "Total Commission paid": "Total Commission paid",
    "Total Referrals": "Total Referrals",
    "Frequently Asked Questions": "Frequently Asked Questions",
    "What if a company cancels?": "What if a company cancels?",
    "When do I receive my commission?": "When do I receive my commission?",
    'Commissions are calculated monthly and paid out within 30 days after the end of each month. Pending commissions will be marked as "paid" once the payment is processed.':
      'Commissions are calculated monthly and paid out within 30 days after the end of each month. Pending commissions will be marked as "paid" once the payment is processed.',
    "What's the minimum payout amount?": "What's the minimum payout amount?",
    "The minimum payout amount is $200. Once you reach this threshold, your earnings will be automatically processed for payment.":
      "The minimum payout amount is €200. Once you reach this threshold, your earnings will be automatically processed for payment.",
    "How can I track my referrals?": "How can I track my referrals?",
    'You can track all your referrals and their status in the "My Earnings" section. This includes pending commissions, paid amounts, and detailed analytics of your referral performance.':
      'You can track all your referrals and their status in the "My Earnings" section. This includes pending commissions, paid amounts, and detailed analytics of your referral performance.',
    "Where can I find my referral code?": "Where can I find my referral code?",
    "Your unique referral code is displayed at the top of this page. Share this code with friends and family to start earning commissions when they sign up and subscribe.":
      "Your unique referral code is displayed at the top of this page. Share this code with friends and family to start earning commissions when they sign up and subscribe.",
    "Refer & Earn": "Refer & Earn",
    "My Earnings": "My Earnings",
    // ResetPassword translations
    "Reset Password": "Reset Password",
    "Reset your password? Let's get you back on the track.":
      "Reset your password? Let's get you back on the track.",
    "Enter New Password": "Enter New Password",
    "Confirm Password": "Confirm Password",
    "Remembered your account?": "Remembered your account?",
    "Password reset successfully!": "Password reset successfully!",
    "Failed to reset password": "Failed to reset password",
    "Confirm Password is required": "Confirm Password is required",
    // AffiliateSignUpForm translations
    "Full Name": "Full Name",
    "Enter Your Full Name": "Enter Your Full Name",
    "Confirm Your Password": "Confirm Your Password",
    "Or Sign up with": "Or Sign up with",
    Dashboard: "Dashboard",
    // AffiliateCommissionTrendsChart translations
    "Commission Trends": "Commission Trends",
    "Select Period": "Select Period",
    Daily: "Daily",
    Monthly: "Monthly",
    Commission: "Commission",
    // AffiliateStats translations
    "Total Earnings": "Total Earnings",
    "Avg. Daily Earnings": "Avg. Daily Earnings",
    "Conversion Rate": "Conversion Rate",
    "Active Affiliates": "Active Affiliates",
    "% from last month": "% from last month",
    // RecentReferralTable translations
    "Recent Referrals": "Recent Referrals",
    "See All": "See All",
    "You have no referrals at the moment. Please use the link below to onboard businesses.":
      "You have no referrals at the moment. Please use the link below to onboard businesses.",
    "N/A": "N/A",
    // RecentTransactions translations
    "Recent Transactions": "Recent Transactions",
    "No recent transactions found.": "No recent transactions found.",
    "Business Name": "Business Name",
    Amount: "Amount",
    Status: "Status",
    Date: "Date",
    pending: "pending",
    paid: "paid",
    // SearchCompaniesTable translations
    "Search Query": "Search Query",
    "Search for businesses (e.g., 'restaurant', 'coffee shop')":
      "Search for businesses (e.g., 'restaurant', 'coffee shop')",
    Location: "Location",
    "Search for a business location...": "Search for a business location...",
    "Business Type": "Business Type",
    "Select business type": "Select business type",
    "Search Radius (miles)": "Search Radius (miles)",
    "Open Now": "Open Now",
    Companies: "Companies",
    results: "results",
    "Error loading businesses:": "Error loading businesses:",
    'No businesses found for "{{query}}". Try adjusting your search criteria.':
      'No businesses found for "{{query}}". Try adjusting your search criteria.',
    "Enter a search query to find businesses.":
      "Enter a search query to find businesses.",
    "Company Name & Address": "Company Name & Address",
    Rating: "Rating",
    Actions: "Actions",
    "No rating": "No rating",
    "View Profile": "View Profile",
    "Visit Website": "Visit Website",
    // ReferralLink translations
    Copied: "Copied",
    Copy: "Copy",
    "Download QR Code": "Download QR Code",
    // AffiliateSearchCompanies translations
    "Search Companies": "Search Companies",
    // AffiliateProfileSettings translations
    Settings: "Settings",
    // AffiliateTransactions translations
    Transactions: "Transactions",
    "Search business name": "Search business name",
    "Payment #": "Payment #",
    "Transaction ID": "Transaction ID",
    // ForgotPassword translations
    "Forgot Password": "Forgot Password",
    "Forgot your password? Let's get you back on the track.":
      "Enter your email and we'll send you a one-time code to reset your password.",
    Next: "Next",
    "OTP has been sent to your email": "OTP has been sent to your email",
    "Failed to send OTP": "Failed to send OTP",
    // SignUp page translations
    "Already have an account?": "Already have an account?",
    "Sign up If you don't have an account":
      "Sign up if you don't have an account",
    // VerifyOtp translations
    "Verify OTP": "Verify OTP",
    "Enter the OTP sent to your email to continue":
      "Enter the OTP sent to your email to continue",
    "Enter OTP": "Enter OTP",
    "Enter 4-digit code": "Enter 4-digit code",
    "OTP is required": "OTP is required",
    "OTP must be 4 digits": "OTP must be 4 digits",
    "Resend OTP": "Resend OTP",
    "OTP verified successfully!": "OTP verified successfully!",
    "Failed to verify OTP": "Failed to verify OTP",
    "OTP resent successfully!": "OTP resent successfully!",
    "Failed to resend OTP": "Failed to resend OTP",
    // ViewBusinessProfileModal translations
    "Loading...": "Loading...",
    Open: "Open",
    "Loading business details...": "Loading business details...",
    "Error loading business details:": "Error loading business details:",
    "Operating Hours": "Operating Hours",
    "Hours not available": "Hours not available",
    Closed: "Closed",
    "Contact Information": "Contact Information",
    "Recent Reviews": "Recent Reviews",
    Showing: "Showing",
    of: "of",
    reviews: "reviews",
    "View all": "View all",
    "reviews on Google": "reviews on Google",
    "View Profile on Google": "View Profile on Google",
    // PageNotFound translations
    "Looks like you've gotten lost! The page you requested is unavailable":
      "Looks like you've gotten lost! The page you requested is unavailable",
    "Head back to the homepage.": "Head back to the homepage.",
    "Page not found": "Page not found",

    "Open menu": "Open menu",
    "Close menu": "Close menu",
    // DashboardLayout navigation translations
    Menu: "Menu",
    Others: "Others",
    Referrals: "Referrals",
    Logout: "Logout",
    "Please complete your affiliate profile setup":
      "Please complete your affiliate profile setup",
    "You have not completed your affiliate profile, please complete it to continue using the platform.":
      "You have not completed your affiliate profile, please complete it to continue using the platform.",
    "Complete Profile": "Complete Profile",
    "Confirm Logout?": "Confirm Logout?",
    "Do you want to exit from app?": "Do you want to exit from app?",
    "No, keep using app": "No, keep using app",
    Yes: "Yes",
  },
};
